/* Phase 3 (2026-10-26): intlTelInput (phone-field plugin) and its 50 KB utils.js are loaded only when a phone
   field is used — the "notify me" form on product pages or the cart exit popup — instead of on every page view.
   URLs come from theme.assets (layout/theme.liquid). */
window.ferlaLoadIntlTel = window.ferlaLoadIntlTel || function () {
  if (window.intlTelInput) { return Promise.resolve(); }
  if (!window.__ferlaItiPromise) {
    window.__ferlaItiPromise = new Promise(function (resolve, reject) {
      var a = (window.theme && window.theme.assets) || {};
      if (a.intlTelInputCss && !document.querySelector('link[href="' + a.intlTelInputCss + '"]')) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = a.intlTelInputCss; document.head.appendChild(l);
      }
      var s = document.createElement('script');
      s.src = a.intlTelInputJs || '/cdn/shop/t/103/assets/intlTelInput.min.js';
      s.onload = function () {
        /* intl-tel-input 17 only fetches utils.js once its own 'load' listener has fired; loaded after the
           load event, that listener never fires, so tell it the window is already loaded. */
        if (document.readyState === 'complete' && window.intlTelInputGlobals) { window.intlTelInputGlobals.windowLoaded = true; }
        resolve();
      };
      s.onerror = function () { window.__ferlaItiPromise = null; reject(new Error('intlTelInput failed to load')); };
      document.head.appendChild(s);
    });
  }
  return window.__ferlaItiPromise;
};

/**
 * ----------------------------------------------------------------------------
 * HEADER
 * ----------------------------------------------------------------------------
 */

document.addEventListener('DOMContentLoaded', () => {
  let nav_drawer = document.getElementsByClassName('js-drawer-open-nav')[0];

  nav_drawer.addEventListener('click', (e) => {
    if (nav_drawer.classList.contains('trm_nav-open') && window.outerWidth > 768) {
      e.stopImmediatePropagation();
      document.querySelector('#NavDrawer .js-drawer-close').click();
    }
    nav_drawer.classList.toggle('trm_nav-open');
  });
});

/**
 * ----------------------------------------------------------------------------
 * SECTIONS
 * ----------------------------------------------------------------------------
 */

/* SECTION: LARGE IMAGE WITH TEXT BOX (IOS FEATURE) ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let paralax_image = document.querySelector('.trm_large-image-with-text-box .parallax-image');

  if (paralax_image && navigator.userAgent.match(/(iPad|iPhone|iPod)/gi)) {
    paralax_image.closest('.trm_large-image-with-text-box').classList.add('parallax-disabled');
    paralax_image.style.backgroundAttachment = 'scroll';
  }
});

/* SECTION: NEWSLETTER 2 ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
	let form = document.getElementsByClassName('trm_newsletter-form');

	if (form.length) {
		for (var i = 0; i < form.length; i++) {
			let name = form[i].getElementsByClassName('trm_name')[0],
				  email = form[i].getElementsByClassName('trm_email')[0],
				  phone = form[i].getElementsByClassName('trm_phone')[0],
				  note = form[i].getElementsByClassName('trm_note')[0];

			form[i].addEventListener('submit', (e) => {
				const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
						  phoneRegExp = /^([+]|[-])*[-\s\.\/0-9]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\.\/0-9]*[x]*$/;

				// Name

				if ( !name.value ) {
					name.classList.add('input-error');
			    name.nextElementSibling.classList.remove('hide');
			    e.preventDefault();
			  }
			  else {
			  	name.classList.remove('input-error');
			  	name.nextElementSibling.classList.add('hide');
			  	note.value = 'Name: ' + name.value;
			  }

			  // Email

        if ( !email.value ) {
          email.nextElementSibling.classList.add('hide');
          email.classList.add('input-error');
          email.nextElementSibling.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        } else if ( !emailRegExp.test( email.value.toLowerCase() ) ) {
          email.nextElementSibling.nextElementSibling.classList.add('hide');
		  		email.classList.add('input-error');
		      email.nextElementSibling.classList.remove('hide');
		      e.preventDefault();
		    }
		    else {
		    	email.classList.remove('input-error');
		    	email.nextElementSibling.classList.add('hide');
          email.nextElementSibling.nextElementSibling.classList.add('hide');
		    }

			  // Phone

        if ( !phone.value ) {
          phone.nextElementSibling.classList.add('hide');
          phone.classList.add('input-error');
          phone.nextElementSibling.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        }
			  else if ( !phoneRegExp.test(phone.value.toLowerCase()) ) {
          phone.nextElementSibling.nextElementSibling.classList.add('hide');
			  	phone.classList.add('input-error');
			    phone.nextElementSibling.classList.remove('hide');
			    e.preventDefault();
			  }
			  else {
			  	phone.classList.remove('input-error');
			  	phone.nextElementSibling.classList.add('hide');
          phone.nextElementSibling.nextElementSibling.classList.add('hide');
			  	note.value += '\nPhone: ' + phone.value;
			  }
			});
		}
	}
});

/* SECTION: IMAGE HOTSPOTS ============================================================================ */

/*! tooltips.js
    v0.1 (c) Mircea Piturca
    MIT License
*/
(function Tooltips(SD){
  'use strict';

  var support = getSupport();
  var instances = nodeList('[data-tooltips-config]');

  instances.map(function(instance){
    var config = Object.freeze(getConfig(instance));

    var publicAPI = {
      tooltips: function() { return getTooltips(config) },
      tooltip: getTooltip,
      select: select,
      deselect: deselect,
      config: config,
      init: init
    }

    if (!SD[config.sectionId]) init(config);
    SD[config.sectionId] = publicAPI;

    return publicAPI;
  })

  // ******************************

  function init(config) {
    var tooltips = getTooltips(config);
    var triggers = pluck(tooltips, 'trigger');

    triggers.map(function(element) {
      element.addEventListener('click', function triggerClick() {
        tooltipClick(tooltips, element.value);
      });
    });

    if (tooltips.length) {
      for (let i = 0; i < tooltips.length; i++) {
        tooltips[i].overlay.addEventListener('click', (e) => {
          let close = tooltips[i].overlay.getElementsByClassName('tooltip-close')[0];

          if (e.target == close && !tooltips[i].collapsed) {
            collapse(tooltips[i]);
          }
        });
      }
    }

    document.addEventListener('click', (e) => {
      const target = e.target;
      let items = document.getElementsByClassName('tooltip-item'),
        buttons =  document.getElementsByClassName('tooltip-button'),
        its_target,
        item_is_active;

      for (let i = 0; i < items.length; i++) {
        let items_button = items[i].getElementsByClassName('tooltip-button')[0],
          items_image = items[i].getElementsByTagName('img')[0],
          items_text = items[i].getElementsByClassName('tooltip-header')[0];

        if (!items_image || !items_text) continue;

        // its_target = target == items[i] || items[i].contains(target);
        its_target = (target == items_image) || (target == items_text) || items_text.contains(target)
          || (target == items_button) || items_button.contains(target);
        item_is_active = buttons[i].getAttribute("aria-expanded") == 'true';

        if (!its_target && item_is_active) {
          for (let i = 0; i < tooltips.length; i++) {
            if ( !tooltips[i].collapsed ) {
              collapse(tooltips[i]);
              return;
            }
          }
        }
      }
    });
  }

  function getConfig(instance) {
    return JSON.parse(instance.innerHTML);
  }

  function getTooltips(config) {
    return config.blocksId.map(getTooltip);
  }

  function getTooltip(id) {
    var host = document.getElementById('tooltip-' + id);

    return {
      id: id,
      trigger: host.querySelector('[data-tooltip-trigger]'),
      overlay: host.querySelector('[data-tooltip-overlay]'),
      markup: host.querySelector('[data-tooltip-markup]'),
      get collapsed() { return isCollapsed(this) }
    }
  }

  function tooltipClick(tooltips, id) {
    var isSelected = partial(idMatch, id);
    
    tooltips.filter(isSelected).map(toggle);
    tooltips.filter(not(isSelected)).filter(not(isCollapsed)).map(collapse);
  }

  function toggle(tooltip) {
    tooltip.collapsed ? expand(tooltip) : collapse(tooltip);
  }

  function expand(tooltip) {
    tooltip.overlay.innerHTML = tooltip.markup.textContent;
    tooltip.overlay.style.setProperty('--end-h', height(tooltip));
    tooltip.overlay.style.setProperty('--start-h', '0px');
    tooltip.trigger.setAttribute('aria-expanded', true);
    tooltip.trigger.style.setProperty('pointer-events', 'none');
    tooltip.overlay.addEventListener('animationend', function animationEndFn() {
      animationReset(tooltip.overlay, animationEndFn);
       tooltip.trigger.style.setProperty('pointer-events', 'auto');
    });

    return tooltip;
  }

  function collapse(tooltip) {
    tooltip.overlay.style.setProperty('--start-h',  height(tooltip));
    tooltip.overlay.style.setProperty('--end-h', '0px');
    tooltip.trigger.setAttribute('aria-expanded', false);
    tooltip.trigger.style.setProperty('pointer-events', 'none');
    if (!support.customProperties) tooltip.overlay.innerHTML = '';

    tooltip.overlay.addEventListener('animationend', function animationEndFn() {
      animationReset(tooltip.overlay, animationEndFn);
      tooltip.overlay.innerHTML = '';
      tooltip.trigger.style.setProperty('pointer-events', 'auto');
    });

    return tooltip;
  }

  function animationReset(element, callback) {
    element.removeAttribute('style');
    element.removeEventListener('animationend', callback);
  }

  function idMatch(id, tooltip) {
    return tooltip.id === id;
  }

  function isCollapsed(tooltip) {
    return attr('aria-expanded', tooltip.trigger) === 'false';
  }

  function height(tooltip) {
    return px(tooltip.overlay.offsetHeight.toString());
  }

  function px(n) {
    return n + 'px';
  }

  /* DOM */
  function attr(str, element) {
    return element.getAttribute(str);
  }

  function nodeList(str, root) {
    if (!root) root = document;
    var nodeList = root.querySelectorAll(str);
    return Array.prototype.slice.call(nodeList);
  }

  /* Fn */
  function not(predicate) {
    return function negated() {
      return !predicate.apply(undefined, arguments);
    };
  }

  function pluck(array, key) {
    return array.map(function(obj) {
      return obj[key];
    });
  }

  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function() {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  /* Support */
  function getSupport() {
    return {
      customProperties: window.CSS && CSS.supports('color', 'var(--primary)'),
    }
  }

  /* Theme editor */
  function select(blockId) {
    return expand(getTooltip(blockId));
  }

  function deselect(blockId) {
    return collapse(getTooltip(blockId));
  }

})(window.SectionsDesign = window.SectionsDesign || {});

/**
 * ----------------------------------------------------------------------------
 * CART
 * ----------------------------------------------------------------------------
 */

/* CART DRAWER. PRODUCTS RECOMMENDED ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {

    
	// Memoize the rendered recommendations HTML keyed on
	// "anchorId|sorted-cart-ids" so the cards (and their <img>) don't get
	// torn down + re-built on every theme.CartDrawer.buildCart() pass —
	// that was causing the visible image flash when the drawer opened.
	var __recCache = window.__trmRecCache || (window.__trmRecCache = {});

	async function loadProductRecommendationsIntoSection(cart) {
		// Cart drawer recommendations — uses Shopify's Product Recommendations
		// API with intent=complementary (auto-trained on real order data, free,
		// tunable via the Search & Discovery app). Anchored on the most
		// expensive item in the cart so accessories follow the headline product.
		var slots = document.querySelectorAll('.trm_cart-popup-recommend');
		if (!slots.length || !cart.items || !cart.items.length) return;

		// Pick anchor = priciest line item (in cents).
		var anchor = cart.items[0];
		for (var i = 1; i < cart.items.length; i++) {
			if (cart.items[i].final_price > anchor.final_price) anchor = cart.items[i];
		}
		var anchorTitle = (anchor.product_title || '').split(' — ')[0].split(' - ')[0].trim();
		var cartIds = cart.items.map(function (it) { return String(it.product_id); });
		var cacheKey = String(anchor.product_id) + '|' + cartIds.slice().sort().join(',');

		// Cache hit — make sure the existing markup is in the slot, but DON'T
		// overwrite innerHTML if it's already there (prevents image flash).
		if (__recCache[cacheKey] != null) {
			slots.forEach(function (el) {
				if (el.dataset.recKey !== cacheKey) {
					el.innerHTML = __recCache[cacheKey];
					el.dataset.recKey = cacheKey;
					wireAddForms(el);
				}
			});
			return;
		}

		function fmt(cents) {
			var d = cents / 100;
			var s = d % 1 === 0 ? d.toFixed(0) : d.toFixed(2);
			return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		}

		function escapeHtml(s) {
			return String(s).replace(/[&<>"']/g, function (c) {
				return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
			});
		}

		function renderProducts(products, limit) {
			var filtered = products.filter(function (p) { return cartIds.indexOf(String(p.id)) === -1; }).slice(0, limit);
			if (!filtered.length) return '';

			var cards = filtered.map(function (p) {
				var img = p.featured_image
					? '<img src="' + p.featured_image + '&width=240" alt="" loading="eager" decoding="async" width="240" height="180">'
					: '';
				var v = p.variants && p.variants[0];
				var available = v && v.available;
				var add = available
					? '<button type="button" class="trm_drawer-cart__rec-add" data-rec-add data-variant-id="' + v.id + '" aria-label="Add ' + escapeHtml(p.title) + ' to cart">'
						+ '<svg width="9" height="9" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
						+ '</button>'
					: '<span class="trm_drawer-cart__rec-soldout">Sold out</span>';

				return '<li class="trm_drawer-cart__rec">'
					+ '<a href="' + p.url + '" class="trm_drawer-cart__rec-img">' + img + '</a>'
					+ '<div class="trm_drawer-cart__rec-body">'
						+ '<a href="' + p.url + '" class="trm_drawer-cart__rec-name">' + escapeHtml(p.title) + '</a>'
						+ '<div class="trm_drawer-cart__rec-foot">'
							+ '<span class="trm_drawer-cart__rec-price">' + fmt(p.price) + '</span>'
							+ add
						+ '</div>'
					+ '</div>'
					+ '</li>';
			}).join('');

			return '<section class="trm_drawer-cart__recs" aria-label="Often bought with ' + escapeHtml(anchorTitle) + '">'
				+ '<header class="trm_drawer-cart__recs-head">'
					+ '<h3 class="trm_drawer-cart__recs-title">Often bought with <span class="trm_drawer-cart__recs-emp">' + escapeHtml(anchorTitle) + '</span></h3>'
				+ '</header>'
				+ '<ul class="trm_drawer-cart__recs-list">' + cards + '</ul>'
				+ '</section>';
		}

		function wireAddForms(el) {
			// Add-to-cart buttons. We can't use a real <form> here because the
			// drawer markup wraps everything in <form action="/cart">, and HTML
			// strips nested <form> tags — that was leaving the first card's
			// inputs floating loose and submitting against the outer cart form.
			// So each button just calls /cart/add.js directly via fetch.
			el.querySelectorAll('[data-rec-add]').forEach(function (btn) {
				if (btn.dataset.wired === '1') return;
				btn.dataset.wired = '1';
				btn.addEventListener('click', function (ev) {
					ev.preventDefault();
					ev.stopPropagation();
					var id = btn.getAttribute('data-variant-id');
					if (!id || btn.disabled) return;
					btn.disabled = true;
					fetch('/cart/add.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
						body: JSON.stringify({ id: id, quantity: 1 })
					})
					.then(function () {
						if (window.jQuery) { window.jQuery('body').trigger('added.ajaxProduct'); }
						document.dispatchEvent(new CustomEvent('cart:refresh'));
					})
					.catch(function () { btn.disabled = false; });
				});
			});
		}

		function fillSlots(html) {
			__recCache[cacheKey] = html;
			slots.forEach(function (el) {
				if (el.dataset.recKey === cacheKey) return;   // already up-to-date
				el.innerHTML = html;
				el.dataset.recKey = cacheKey;
				wireAddForms(el);
			});
		}

		var limit = 6;
		var anchorId = anchor.product_id;

		// Try complementary first → fall back to related → empty out if both fail.
		try {
			var resp = await fetch('/recommendations/products.json?intent=complementary&product_id=' + anchorId + '&limit=' + (limit + cartIds.length));
			var data = await resp.json();
			var html = renderProducts(data.products || [], limit);
			if (!html) {
				var resp2 = await fetch('/recommendations/products.json?intent=related&product_id=' + anchorId + '&limit=' + (limit + cartIds.length));
				var data2 = await resp2.json();
				html = renderProducts(data2.products || [], limit);
			}
			fillSlots(html);
		} catch (e) {
			fillSlots('');
		}
	};
    
	document.getElementById('CartDrawer').addEventListener('trm_cart', (e) => {
		if (e.detail.cart.items.length) {
			loadProductRecommendationsIntoSection(e.detail.cart);
		}
	});
});

/* CART PAGE. EXIT-INTENT POPUP ================================================================================= */

(function() {
  let exit_popup = document.getElementsByClassName('trm_cart-exit-popup-wrap')[0];
  if (exit_popup) {

    exit_popup = {
      el: exit_popup,
      close: exit_popup.getElementsByClassName('trm_cart-exit-popup-close')[0],
      wrap: exit_popup.getElementsByClassName('trm_cart-exit-popup-dialog')[0],
      field_phone: exit_popup.querySelector('[type="phone"]'),
      form: exit_popup.getElementsByTagName('form')[0]
    };

    function ExitPopup() {
      exit_popup.options = JSON.parse(exit_popup.el.getAttribute('data-popup-settings'));
      exit_popup.hasOpenOnceInCurrentPage = false; // If the popup has been already displayed, we do not display it
      attachListeners(); // fieldPhone() runs on the first openPopup() (phase 3)

      try {
        if (window.location.hash === '#exit-popup' && window.theme.pageType === 'cart') {
          openPopup();
        }
      } catch (error) {
        // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }
    }

    function attachListeners() {
      exit_popup.close.addEventListener('click', closePopup);
      exit_popup.form.addEventListener('submit', formSubmit);

      document.body.addEventListener('mouseleave', () => {
        if (!exit_popup.hasOpenOnceInCurrentPage) {
          if (!exit_popup.options['showOnlyOnce'] || exit_popup.options['showOnlyOnce'] && localStorage.getItem('themeExitPopup') === null) {
            openPopup();
          }
        }
      });
    }

    function openPopup() {
      if (!exit_popup.iti && !exit_popup.itiLoading) {
        exit_popup.itiLoading = true;
        window.ferlaLoadIntlTel().then(fieldPhone).catch(function () { exit_popup.itiLoading = false; });
      }
      exit_popup.el.setAttribute('aria-hidden', 'false');
      localStorage.setItem('themeExitPopup', 'true');
      document.body.classList.add('trm_popup-open');
      exit_popup.hasOpenOnceInCurrentPage = true;
      window.theme.isExitPopupOpen = true;

      exit_popup.el.addEventListener('click', checkClickOutside)
      document.body.addEventListener('keyup', onKeyPressed);
    }

    function closePopup() {
      exit_popup.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('trm_popup-open');
      window.theme.isExitPopupOpen = false;
    }

    function checkClickOutside(e) {
      if (!exit_popup.el.contains(e.target) || exit_popup.el === e.target) {
        closePopup();
      }
    }

    function onKeyPressed(e) {
      if (e.key === 'Escape') {
        closePopup();
      }
    }

    function fieldPhone() {
      // initialise plugin
      exit_popup.iti = window.intlTelInput(exit_popup.field_phone, {
        utilsScript: (window.theme && window.theme.assets && window.theme.assets.intlTelInputUtils) || '//ferlafamilybikes.com/cdn/shop/t/103/assets/utils.js?v=64460994516617330181791497270'
      });

      var errorMsg = exit_popup.field_phone.closest('.iti--allow-dropdown').nextElementSibling;

      // here, the index maps to the error code returned from getValidationError - see readme
      var errorMap = ["Please enter a valid phone number", "Invalid country code", "Please enter a valid phone number", "Please enter a valid phone number", "Please enter a valid phone number"];

      var reset = function () {
        exit_popup.field_phone.classList.remove("error");
        errorMsg.innerHTML = "";
        errorMsg.classList.add("hide");
      };

      // on blur: validate
      exit_popup.field_phone.addEventListener('blur', function () {
        reset();
        if (exit_popup.field_phone.value.trim()) {
          if (!exit_popup.iti.isValidNumber()) {
            exit_popup.field_phone.classList.add("error");
            var errorCode = exit_popup.iti.getValidationError();
            errorMsg.innerHTML = errorMap[errorCode];
            errorMsg.classList.remove("hide");
          }
        }
      });

      // on keyup / change flag: reset
      exit_popup.field_phone.addEventListener('change', reset);
      exit_popup.field_phone.addEventListener('keyup', reset);
    }

    function formSubmit() {
      let field_note = exit_popup.form.querySelector('[name="contact[note]"]');
      field_note.value = (exit_popup.iti && window.intlTelInputUtils) ? exit_popup.iti.getNumber(intlTelInputUtils.numberFormat.E164) : exit_popup.field_phone.value;
    }

    document.addEventListener('shopify:section:select', (e) => {
      let id = e.detail.sectionId;

      if (id == 'trm_cart-exit-intent-popup') {
        openPopup();
      }
    });

    document.addEventListener('shopify:section:deselect', (e) => {
      let id = e.detail.sectionId;

      if (id == 'trm_cart-exit-intent-popup') {
        closePopup();
      }
    });

    ExitPopup();
  }
}());

/* FOR ASSEMBLY ================================================================================= */

document.addEventListener('DOMContentLoaded', () => {

  /* ADD TO CART --------------------------------------------------------------------------------- */

  document.body.addEventListener('trm_product_added_to_cart', (e) => {
    let product = e.detail;

    if (product.product_type == 'Cargo Bike') {
      const data = {
        items: [{
          quantity: 1,
          id: theme.settings.productAssemblyId // Product 'Assembly' (https://ferlafamilybike.myshopify.com/admin/products/6176573587612)
        }]
      };

      theme.cart._updateCart({
        type: 'POST',
        url: theme.routes.cartAdd,
        data: data,
        dataType: 'json'
      });
      
    }
  });

  /* CART DRAWER. CHANGE QUANTITY --------------------------------------------------------------------------------- */

  document.body.addEventListener('trm_product_change_qty', (e) => {
    let cart = e.detail,
      bikes_qty = 0,
      assembly = { quantity: 0, key: '', data: '' };

    for (let i = 0; i < cart.items.length; i++) {
      let item = cart.items[i];
      if (item.product_type === 'Cargo Bike') {
        bikes_qty += item.quantity;
      }
      else if (item.variant_id === theme.settings.productAssemblyId) {
        assembly.quantity = item.quantity;
        assembly.key = item.key;
      }
    }
    
    if (assembly.key && assembly.quantity !== bikes_qty) {
      assembly.data = 'quantity=' + bikes_qty + '&id=' + assembly.key;

      let ajax_settings = {
        type: 'POST',
        url: theme.routes.cartChange,
        data: assembly.data,
        dataType: 'json'
      };

      if (theme.pageType === 'cart') {
        ajax_settings.success = () => {
          document.location.reload();
        }
      }

      theme.cart._updateCart(ajax_settings);
    }
    else if (theme.pageType === 'cart') {
      document.location.reload();
    }
  });

  /* CART PAGE. CHANGE QUANTITY --------------------------------------------------------------------------------- */

  let qtys = document.querySelectorAll('.template-cart .cart__product-qty'),
      assembly_qty = document.querySelector('.template-cart .cart__row.trm_assembly .cart__product-qty'),
      dualBatteryAddOnProduct = document.querySelector('.trm_cart-items .dual-battery-addon-product'),
      dualBatteryAddOnProductQty = dualBatteryAddOnProduct ? dualBatteryAddOnProduct.querySelector('.cart__product-qty') : null,
      dualBatteryLongtailProducts = document.querySelectorAll('.trm_cart-items .dual-battery-longtail-product');

  if (qtys.length > 0) {
    let update = document.getElementsByClassName('cart__update')[0];

    for (let i = 0; i < qtys.length; i++) {
      let dualBatteryLongtailProductsQty = 0;
      let timerId;

      qtys[i].addEventListener('change', () => {
        clearTimeout(timerId);

        timerId = setTimeout(() => {

          if (dualBatteryAddOnProduct) {
            dualBatteryLongtailProducts.forEach( dualBatteryLongtailProduct => {
              const dualBatteryLongtailProductQty = dualBatteryLongtailProduct.querySelector('.cart__product-qty').value;
              dualBatteryLongtailProductsQty += parseInt(dualBatteryLongtailProductQty);
            });
  
            dualBatteryAddOnProductQty.value = dualBatteryLongtailProductsQty;
          }
          
          if (qtys[i].dataset.productType === 'Cargo Bike' && assembly_qty != undefined) {

            let assembly_val = +assembly_qty.dataset.productQty,
              product_val = +qtys[i].dataset.productQty,
              product_val_new = +qtys[i].value,
              assembly_val_new = (product_val < product_val_new) ? assembly_val + (product_val_new - product_val) : assembly_val - (product_val - product_val_new);

            if (assembly_val_new < 0) {
              assembly_val_new = 0;
            }

            assembly_qty.value = assembly_val_new;
            update.click();
          } else {
            update.click();
          }
        }, 300);
      });
    }
  }

  if (dualBatteryAddOnProduct) {
    dualBatteryLongtailProducts.forEach( dualBatteryLongtailProduct => {
      dualBatteryLongtailProduct.querySelector('.trm_cart-product-delete').addEventListener('click', (e) => {
        e.preventDefault();

        dualBatteryAddOnProductQty.value = parseInt(dualBatteryAddOnProductQty.value) - parseInt(dualBatteryLongtailProduct.querySelector('.cart__product-qty').value);

        dualBatteryLongtailProduct.querySelector('.cart__product-qty').value = 0;

        let update = document.getElementsByClassName('cart__update')[0];
        if (update) update.click();
      });
    });
  }

  /* CART PAGE. ADD ASSEMBLY --------------------------------------------------------------------------------- */

  (function() {
    let btn = document.getElementsByClassName('trm_cart-featured-collection-assembly--submit')[0];

    if (btn) {
      let bikes = document.querySelectorAll('.trm_cart-items .cart__row.trm_type-cargo-bike');

      btn.addEventListener('click', (e) => {
        if (bikes.length) {
          let bikes_qty = 0;

          for (let i = 0; i < bikes.length; i++) {
            bikes_qty += +bikes[i].getElementsByClassName('cart__product-qty')[0].value;
          }

          if (bikes_qty < 1) {
            bikes_qty = 1;
          }

          btn.previousElementSibling.value = bikes_qty;
        }
      });
    }
  }());

  /* CART PAGE. DELETE ASSEMBLY --------------------------------------------------------------------------------- */

  (function(){
    let items = document.querySelectorAll('.trm_cart-items .cart__row'),
      assembly = document.querySelector('.trm_cart-items .cart__row.trm_assembly');

    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].classList.contains('trm_type-cargo-bike') && assembly) {
          let item_remove = items[i].getElementsByClassName('trm_cart-product-delete')[0],
            item_qty = items[i].getElementsByClassName('cart__product-qty')[0],
            assembly_qty = assembly.getElementsByClassName('cart__product-qty')[0],
            update = document.getElementsByClassName('cart__update')[0];

          item_remove.addEventListener('click', (e) => {
            e.preventDefault();

            let assembly_val_new = assembly_qty.value - item_qty.value;

            if (assembly_val_new < 0) {
              assembly_val_new = 0;
            }

            item_qty.value = 0;
            assembly_qty.value = assembly_val_new;
            update.click();
          });
        }

        if (items[i].classList.contains('trm_assembly')) {

          let assembly_remove_popup = {
            btn: items[i].getElementsByClassName('trm_cart-product-delete')[0],
            el: document.getElementsByClassName('trm_cart-popup-remove-assembly--wrap')[0],
            wrap: document.getElementsByClassName('trm_cart-popup-remove-assembly--dialog')[0],
            close: document.getElementsByClassName('trm_cart-popup-remove-assembly--close')[0],
            cancel: document.getElementsByClassName('trm_cart-popup-remove-assembly--cancel')[0],
            approve: document.getElementsByClassName('trm_cart-popup-remove-assembly--approve')[0]
          };

          assembly_remove_popup.remove_link = assembly_remove_popup.btn.href;
          assembly_remove_popup.close.addEventListener('click', closePopup);
          assembly_remove_popup.el.addEventListener('click', checkClickOutside);
          document.body.addEventListener('keyup', onKeyPressed);

          function openPopup() {
            document.body.classList.add('trm_popup-open');
            assembly_remove_popup.el.setAttribute('aria-hidden', 'false');
          }

          function closePopup() {
            document.body.classList.remove('trm_popup-open');
            assembly_remove_popup.el.setAttribute('aria-hidden', 'true');
          }

          function checkClickOutside(e) {
            if (!assembly_remove_popup.el.contains(e.target) || assembly_remove_popup.el === e.target) {
              closePopup();
            }
          }

          function onKeyPressed(e) {
            if (e.key === 'Escape') {
              closePopup();
            }
          }

          assembly_remove_popup.btn.addEventListener('click', (e) => {
            e.preventDefault();
            openPopup();
          });

          assembly_remove_popup.cancel.addEventListener('click', () => {
            closePopup();
          });

          assembly_remove_popup.approve.addEventListener('click', () => {
            window.location.href = assembly_remove_popup.remove_link;
          });

          document.addEventListener('shopify:section:select', (e) => {
            let id = e.detail.sectionId;

            if ( id == 'trm_cart-popup-remove-assembly' ) {
              openPopup();
            }
          });

          document.addEventListener('shopify:section:deselect', (e) => {
            let id = e.detail.sectionId;

            if ( id == 'trm_cart-popup-remove-assembly' ) {
              closePopup();
            }
          });
        }
      }
    }
  }());
});

/**
 * ----------------------------------------------------------------------------
 * PRODUCT PAGE
 * ----------------------------------------------------------------------------
 */

/* NOTIFYING, WHEN PRODUCT VARIANT OUT OF STOCK ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let inputs = document.getElementsByClassName('trm_product-notify-me-contact-phone'),
    links = document.getElementsByClassName('trm_product-notify-me');

  /* Phase 3: the plugin (+ utils.js) loads the first time the notify-me form is opened or its phone field
     focused, instead of on every product page view. */
  var phonesReady = false;
  function initPhones() {
    if (phonesReady || !inputs.length) return;
    phonesReady = true;
    window.ferlaLoadIntlTel().then(bindPhones).catch(function () { phonesReady = false; });
  }
  if (links) {
    for (let i = 0; i < links.length; i++) {
      links[i].addEventListener('click', () => {
        links[i].closest('.product-single__form').nextElementSibling.getElementsByClassName('trm_product-notify-me-contact')[0].classList.toggle('trm_hidden');
        initPhones();
      });
    }
  }
  for (let i = 0; i < inputs.length; i++) { inputs[i].addEventListener('focus', initPhones); }

  function bindPhones() {
  var focused = null;
  for (let i = 0; i < inputs.length; i++) { if (inputs[i] === document.activeElement) focused = inputs[i]; }
  if (inputs) {
    for (let i = 0; i < inputs.length; i++) {
      // initialise plugin
      var iti = window.intlTelInput(inputs[i], {
        utilsScript: (window.theme && window.theme.assets && window.theme.assets.intlTelInputUtils) || '//ferlafamilybikes.com/cdn/shop/t/103/assets/utils.js?v=64460994516617330181791497270'
      });

      var errorMsg = inputs[i].closest('.iti--allow-dropdown').nextElementSibling;

      // here, the index maps to the error code returned from getValidationError - see readme
      var errorMap = ["Please enter a valid phone number", "Invalid country code", "Please enter a valid phone number", "Please enter a valid phone number", "Please enter a valid phone number"];

      var reset = function() {
        inputs[i].classList.remove("error");
        errorMsg.innerHTML = "";
        errorMsg.classList.add("hide");
      };

      // on blur: validate
      inputs[i].addEventListener('blur', function() {
        reset();
        if (inputs[i].value.trim()) {
          if (!iti.isValidNumber()) {
            inputs[i].classList.add("error");
            var errorCode = iti.getValidationError();
            errorMsg.innerHTML = errorMap[errorCode];
            errorMsg.classList.remove("hide");
          }
        }
      });

      // on keyup / change flag: reset
      inputs[i].addEventListener('change', reset);
      inputs[i].addEventListener('keyup', reset);
    }
  }
  if (focused) { try { focused.focus(); } catch (e) {} } // the plugin re-parents the input, which drops focus
  }
});

/* BLOCK: FEATURED COLLECTION ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let page_block_featured_product_2 = document.getElementsByClassName('trm_featured-products-block-carousel');

  if (page_block_featured_product_2.length > 0) {
    for (let i = 0; i < page_block_featured_product_2.length; i++) {
      $(page_block_featured_product_2[i]).slick({
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false
            }
          }
        ]
      });
    }
  }
});

/* BLOCK: FEATURED COLLECTION 2 ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let button = document.querySelector('.trm_page-block-featured-collection-2 > .trm_button-black'),
      products = document.querySelectorAll('.trm_page-block-featured-collection-2-block');

  if (button) {
    button.addEventListener('click', () => {
      for (let i = 0; i < products.length; i++) {
        products[i].classList.remove('trm_hidden');
      }

      button.remove();
    });
  }
});

/* BLOCK: SPECIFICATIONS ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let dots = document.querySelectorAll('.trm_page-block-specifications-item-title'),
      items = document.querySelectorAll('.trm_page-block-specifications-item-title + ul');

  if (dots) {
    for (let i = 0; i < dots.length; i++) {
      dots[i].addEventListener('click', () => {
        dots[i].classList.toggle('open');
        items[i].classList.toggle('trm_hidden');
      });
    }
  }
});



/* BLOCK: IMAGE WITH TEXT READMORE ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let text = document.querySelectorAll('.trm_page-block-image-with-text-readmore-text-readmore'),
      btn = document.querySelectorAll('.trm_page-block-image-with-text-readmore .trm_button');

  if (text) {
    for (let i = 0; i < text.length; i++) {
      btn[i].addEventListener('click', () => {
        text[i].classList.toggle('expanded');
        btn[i].classList.toggle('trm_hidden');
      });
    }
  }
});

/* BLOCK: READMORE ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let text = document.querySelectorAll('.text-readmore'),
      btn = document.querySelectorAll('.seemore-button');

  if (text) {
    for (let i = 0; i < text.length; i++) {
      btn[i].addEventListener('click', () => {
        text[i].classList.toggle('trm_hidden');
        //btn[i].classList.toggle('trm_hidden');
      });
    }
  }
});

/**
 * ----------------------------------------------------------------------------
 * COLLECTION PAGE
 * ----------------------------------------------------------------------------
 */

/* GALLERY ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  let images = document.querySelectorAll('.trm_collection-images.carousel');

  if (images.length > 0) {
    for (let i = 0; i < images.length; i++) {
      let gallery = images[i].getElementsByClassName('trm_collection-gallery')[0],
          thumbnails = images[i].getElementsByClassName('trm_collection-thumbnails')[0].children;

      $(gallery).slick({
        draggable: false,
        swipe: false,
        arrows: false
      });

      for (let i = 0; i < thumbnails.length; i++) {
        thumbnails[i].addEventListener('click', () => {
          $(gallery).slick('slickGoTo', i,  true);
        });
      }
    }
  }
});

/**
 * ----------------------------------------------------------------------------
 * CONTACT US PAGE
 * ----------------------------------------------------------------------------
 */

document.addEventListener('DOMContentLoaded', () => {
  let form = document.getElementsByClassName('trm_page-block-contact-form');

  if (form.length) {
    for (var i = 0; i < form.length; i++) {
      let name = form[i].getElementsByClassName('trm_name')[0],
        email = form[i].getElementsByClassName('trm_email')[0],
        phone = form[i].getElementsByClassName('trm_phone')[0],
        message = form[i].getElementsByClassName('trm_message')[0];

      form[i].addEventListener('submit', (e) => {
        const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          phoneRegExp = /^([+]|[-])*[-\s\.\/0-9]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\.\/0-9]*[x]*$/;
 
        // Name

        if ( !name.value ) {
          name.classList.add('input-error');
          name.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        }
        else {
          name.classList.remove('input-error');
          name.nextElementSibling.classList.add('hide');
        }

        // Email

        if ( !email.value ) {
          email.nextElementSibling.classList.add('hide');
          email.classList.add('input-error');
          email.nextElementSibling.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        } else if ( !emailRegExp.test( email.value.toLowerCase() ) ) {
          email.nextElementSibling.nextElementSibling.classList.add('hide');
          email.classList.add('input-error');
          email.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        }
        else {
          email.classList.remove('input-error');
          email.nextElementSibling.classList.add('hide');
          email.nextElementSibling.nextElementSibling.classList.add('hide');
        }

        // Phone

        if ( !phone.value ) {
          phone.nextElementSibling.classList.add('hide');
          phone.classList.add('input-error');
          phone.nextElementSibling.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        }
        else if ( !phoneRegExp.test(phone.value.toLowerCase()) ) {
          phone.nextElementSibling.nextElementSibling.classList.add('hide');
          phone.classList.add('input-error');
          phone.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        }
        else {
          phone.classList.remove('input-error');
          phone.nextElementSibling.classList.add('hide');
          phone.nextElementSibling.nextElementSibling.classList.add('hide');
        }

        // Message

        if ( !message.value ) {
          message.classList.add('input-error');
          message.nextElementSibling.classList.remove('hide');
          e.preventDefault();
        }
        else {
          message.classList.remove('input-error');
          message.nextElementSibling.classList.add('hide');
        }
      });
    }
  }
});